import { createFileRoute } from "@tanstack/react-router";
import { ProceduresTable } from "@/modules/procedures/table";

export const Route = createFileRoute("/dashboard/patients/$patientId/procedures/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { patientId } = Route.useParams();
	return <ProceduresTable patientId={patientId} />;
}
